import Axios from 'axios';
var PriceAnalyzeService = (function () {
    function PriceAnalyzeService() {
    }
    PriceAnalyzeService.prototype.getList = function (params) {
        return Axios.get('supplierclientapi/purchase_report/price_analyze', { params: params });
    };
    PriceAnalyzeService.prototype.getDetail = function (params) {
        return Axios.get('supplierclientapi/purchase_report/price_analyze_detail', { params: params });
    };
    PriceAnalyzeService.createInstance = function () {
        PriceAnalyzeService.getInstance();
    };
    PriceAnalyzeService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    return PriceAnalyzeService;
}());
export default PriceAnalyzeService;
